import Vue from "vue";

export const store = Vue.observable({
    showChild: {
        0: false,
        1: false,
        2: false,
        3: false
    }
});

export const mutations = {
    setShowChild(index) {
        for (let [key,value] of Object.entries(store.showChild)) {
            if(key == index){
                store.showChild[key] = !value
            }else{
                store.showChild[key] = false;
            }
        }
    }
};
